import { AllWorkoutsBySectionScreen } from './all-workouts-by-section/all-workouts-by-section-screen'
import { authRoutes } from './auth/auth-routes'
import { AwardsScreen } from './awards-screen'
import { CheckoutScreen } from './checkout-screen'
import { CoreChargeWorkoutsScreen } from './core-charge-workouts-screen/core-charge-workouts-screen'
import { DebugScreen } from './debug-screen'
import { EducationScreen } from './education/education'
import { FlexFlowWorkoutsScreen } from './flex-flow-workouts-screen/flex-flow-workouts-screen'
import { HomeScreen } from './home-screen'
import { KeepGoingScreen } from './keep-going-screen'
import { LegalAgreementCheckScreen } from './legal-agreement-check-screen'
import { ActiveSeriesScreen } from './profile/overview/active-series-screen'
import { CompletedSeriesScreen } from './profile/overview/completed-series-screen'
import { CompletedWorkoutsScreen } from './profile/overview/completed-workouts-screen'
import { PrivacyPolicyScreen } from './profile/personal-info/privacy-policy'
import { TermsConditionsScreen } from './profile/personal-info/terms-conditions'
import { ProfileScreen } from './profile/profile-screen'
import { ProgrammeListScreen } from './programme/programme-list-screen'
import { ProgrammeOverviewScreen } from './programme/programme-overview-screen'
import { ProgrammeWorkoutScreen } from './programme-workout/programme-workout-screen'
import { SignOutScreen } from './sign-out-screen'
import { TrainerWorkoutsScreen } from './trainer/trainer-workouts-screen'
import { TrainingSeriesListScreen } from './training-series-list-screen/training-series-list-screen'
import { TrainingSeriesOverviewScreen } from './training-series-overview/training-series-overview'
import { WorkoutListScreen } from './workout/workout-list-screen'
import { WorkoutScreen } from './workout/workout-screen'
import { WorkoutPresetScreen } from './workout-preset-screen/workout-preset-screen'
import { CommunityScreen } from './community-screen'
import { AdminGroupsScreen } from './admin/admin-groups-screen'
import { AdminGroupDetailScreen } from './admin/admin-group-detail-screen'
import { AdminCommentsScreen } from './admin/admin-comments-screen'
import { FilterContextProvider } from '../context/filter-context'
import React from 'react'
import { Navigate, Outlet, RouteObject } from 'react-router-dom'

export const routes: RouteObject[] = [
  // Auth routes (public - no auth required)
  ...authRoutes,
  // Core routes (require authentication - handled by AuthInitiate in App)
  {
    path: '/',
    element: <HomeScreen />,
  },
  // Trainer dialog opens as overlay on top of home screen - see TrainerDialog in App.tsx
  {
    path: '/trainers/:trainerId',
    element: <HomeScreen />,
  },
  {
    path: '/workouts',
    element: (
      <FilterContextProvider>
        <WorkoutListScreen />
      </FilterContextProvider>
    ),
  },
  {
    path: '/workouts/:workoutId',
    element: <WorkoutScreen />,
  },
  {
    path: '/workouts-preset/:preset',
    element: <WorkoutPresetScreen />,
  },
  {
    path: '/core-charge-workouts',
    element: <CoreChargeWorkoutsScreen />,
  },
  {
    path: '/flex-flow-workouts',
    element: <FlexFlowWorkoutsScreen />,
  },
  {
    path: '/workouts/section/:sectionId',
    element: (
      <FilterContextProvider>
        <AllWorkoutsBySectionScreen />
      </FilterContextProvider>
    ),
  },
  {
    path: '/trainers/:trainerId/workouts',
    element: <TrainerWorkoutsScreen />,
  },
  {
    path: '/awards',
    element: <AwardsScreen />,
  },
  {
    path: '/programmes',
    element: <ProgrammeListScreen />,
  },
  {
    path: '/programmes/:programmeId',
    element: <ProgrammeOverviewScreen />,
  },
  {
    path: '/education',
    element: <EducationScreen />,
  },
  {
    path: '/programmes/:programmeId/programme-workouts/:programmeWorkoutId/workouts/:workoutId',
    element: <ProgrammeWorkoutScreen />,
  },
  { path: '/groups/*', element: <CommunityScreen /> },
  { path: '/admin/groups', element: <AdminGroupsScreen /> },
  { path: '/admin/groups/:groupId', element: <AdminGroupDetailScreen /> },
  { path: '/admin/comments', element: <AdminCommentsScreen /> },
  {
    path: '/training-series',
    element: <TrainingSeriesListScreen />,
  },
  {
    path: '/training-series/:trainingSeriesId',
    element: <TrainingSeriesOverviewScreen />,
  },
  {
    path: '/active-series',
    element: <ActiveSeriesScreen />,
  },
  {
    path: '/keep-going',
    element: <KeepGoingScreen />,
  },
  {
    path: '/completed-series',
    element: <CompletedSeriesScreen />,
  },
  {
    path: '/completed-workouts',
    element: <CompletedWorkoutsScreen />,
  },
  {
    path: '/profile/*',
    element: <ProfileScreen />,
  },
  {
    path: '/checkout',
    element: <CheckoutScreen />,
  },
  {
    path: '/sign-out',
    element: <SignOutScreen />,
  },
  {
    path: '/legal-agreement-check',
    element: <LegalAgreementCheckScreen />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyScreen />,
  },
  {
    path: '/terms-conditions',
    element: <TermsConditionsScreen />,
  },
  // Development-only debug routes
  ...(process.env.NODE_ENV === 'development'
    ? [
        {
          path: '/debug',
          element: <DebugScreen />,
        },
      ]
    : []),
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]

// Keep Router component for backward compatibility - now just renders Outlet
export const Router = (): React.ReactElement => <Outlet />
